import { render } from "./Spotlight.vue?vue&type=template&id=2957c336"
import script from "./Spotlight.vue?vue&type=script&lang=js"
export * from "./Spotlight.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__